import { getActiveModule, getModuleById } from "../../store";
import { ModuleTypes } from "../../lib/types";
import { deepChange, goToModule } from "../../actions";
import { getModuleBeforeGallery } from "./selectors";
import { UserEventsAPI } from "../../lib/userEventsAPI";

/**
 * Save the number of the module which preceded the gallery.
 * We need to know this to open it back again once user closes the gallery.
 * @param moduleID
 * @returns {Function}
 */
export const saveModuleBeforeGallery = (moduleID) => (dispatch, getState) => {
  const state = getState();
  if (getModuleBeforeGallery(state) && moduleID !== null) {
    return;
  }
  dispatch(deepChange({ moduleBeforeGallery: moduleID }));
};

/**
 * Closes both the gallery and the floorplans.
 * UPD: now the floorplans are not supported but instead we have modules which can
 * be shown as a gallery.
 * @returns {Function}
 */
export const closeGallery = () => (dispatch, getState) => {
  const state = getState();
  const activeModule = getActiveModule(state);
  if (
    activeModule.isGallery() ||
    activeModule.isFloorplan() ||
    activeModule.isAdvancedFloorplan() ||
    activeModule.isVideo() ||
    activeModule.isDigitalTour()
  ) {
    const moduleIdBeforeGallery = getModuleBeforeGallery(state);
    const moduleBeforeGallery = getModuleById(state, moduleIdBeforeGallery);
    dispatch(saveModuleBeforeGallery(null));
    if (moduleBeforeGallery.type === ModuleTypes.submit || moduleBeforeGallery.type === ModuleTypes.eval) {
      dispatch(goToModule(1));
    } else {
      dispatch(goToModule(moduleIdBeforeGallery, { quiet: true }));
    }
  }
};

/**
 * Fired by the gallery when another slide is activated.
 * For the floorplans.
 * @param index - new slide index
 */
export const onFloorPlanSlide = (index) => (dispatch) => {
  dispatch(deepChange({ "activeModule.activeFloor": index }));
  dispatch(UserEventsAPI.sendFloorplanChange(index));
};

/**
 * Fired by the gallery when another slide is activated.
 * For the images gallery.
 * @param index - new slide index.
 */
export const onGallerySlide = (index) => (dispatch) => {
  dispatch(UserEventsAPI.sendImageSlideChange(index));
};
